const JobHistory = () => {
    return <>
    </>
}

export default JobHistory;